import { render, staticRenderFns } from "./statuses_label.vue?vue&type=template&id=16e22dae&scoped=true&"
import script from "./statuses_label.vue?vue&type=script&lang=js&"
export * from "./statuses_label.vue?vue&type=script&lang=js&"
import style0 from "./statuses_label.vue?vue&type=style&index=0&id=16e22dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e22dae",
  null
  
)

export default component.exports